module.exports = __webpack_public_path__ + "img/zh_s.8c53f1c6.png";